var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoonBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5297 15.9294C21.3697 15.6594 20.9197 15.2394 19.7997 15.4394C19.1797 15.5494 18.5497 15.5994 17.9197 15.5694C15.5897 15.4694 13.4797 14.3994 12.0097 12.7494C10.7097 11.2994 9.90971 9.40938 9.89971 7.36938C9.89971 6.22938 10.1197 5.12938 10.5697 4.08938C11.0097 3.07938 10.6997 2.54938 10.4797 2.32938C10.2497 2.09938 9.70971 1.77938 8.64971 2.21938C4.55971 3.93938 2.02971 8.03938 2.32971 12.4294C2.62971 16.5594 5.52971 20.0894 9.36971 21.4194C10.2897 21.7394 11.2597 21.9294 12.2597 21.9694C12.4197 21.9794 12.5797 21.9894 12.7397 21.9894C16.0897 21.9894 19.2297 20.4094 21.2097 17.7194C21.8797 16.7894 21.6997 16.1994 21.5297 15.9294Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonBold);
export default __webpack_public_path__ + "static/media/moon-bold.99fb85e71f89847ec13df352cee1423f.svg";
export { ForwardRef as ReactComponent };